import React, { useState, useCallback, useEffect, useRef } from 'react';
import RGL, { WidthProvider } from 'react-grid-layout';
import AddSvg from '../../../svg/admin/Add';
import '../../../../node_modules/react-grid-layout/css/styles.css';
import '../../../../node_modules/react-resizable/css/styles.css';
import DropDownMenu from '../../components/DropDownMenu';
import _ from 'lodash';
import MDEditor from '@uiw/react-md-editor';
import SelectHighlighttext from './SelectHighlighttext'
import {
    PRIMARY_ABILITY_POINTS_LIST as ABILITY_POINTS_LIST,
    PRIMARY_ABILITY_POINTS_DICT as ABILITY_POINTS_DICT,
    PRIMARY_ABILITY_POINTS_DICT_2 as ABILITY_POINTS_DICT_2
} from '../../../dto/chart';

const ReactGridLayout = WidthProvider(RGL);

const rowHeight = 90
const numOfRow = 9
const convertToLayout = (data) => { return data?.map((item, index) => ({ i: `${index}`, x: 0, y: index * numOfRow, w: 1, h: numOfRow, data: item })) || [] }

function Component(props) {
    const [layout, setlayout] = useState(convertToLayout(props.data?.questions || []));
    useEffect(() => {
        //work around for issue of ReactGridLayout not updating width
        window.dispatchEvent(new Event('resize'));
    }, [layout]);
    useEffect(() => {
        setlayout(convertToLayout(props.data?.questions || []))
    }, [props.data])

    const onDragStop = useCallback((layout) => (layout_, oldItem, newItem) => {
        const clonelayout = [...layout_]//_.cloneDeep(layout);
        const index = _.findIndex(layout, { 'i': oldItem.i })
        let dragY = clonelayout[index].y
        if (layout[index].y < dragY) {
            for (let i in layout) {
                if (layout[i].y <= dragY && layout[i].y > layout[index].y)
                    clonelayout[i].y = layout[i].y - 1
            }
        } else if (layout[index].y > dragY) {
            for (let i in layout) {
                if (layout[i].y >= dragY && layout[i].y < layout[index].y)
                    clonelayout[i].y = layout[i].y + 1
            }
        } else return
        clonelayout[index].y = dragY
        setlayout(clonelayout)
        if (props.updateOrder) props.updateOrder(layout, clonelayout)
    }, [layout])

    const onAddCard = () => { if (props.onAddCard) props.onAddCard() }
    const onDelete = (item, index) => () => { if (props.onDelete) { props.onDelete(item, index) } };
    const onEditKey = (item, index, key) => (e) => { if (props.onEditKey) props.onEditKey(item, index, key, e.target.value) };
    const onEditTableHeader = (item, index, key) => (e) => {
        let newHeader = item.data?.header || []
        newHeader[key] = e.target.value
        if (props.onEditKey) props.onEditKey(item, index, 'header', newHeader)
    };
    const handleSelectQuestionType = (item, index) => (type, typeIndex) => {
        if (props.onEditKey) props.onEditKey(item, index, 'type', type);
    }

    const handleAddOption = (item, index) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'options', [...item.data?.options || [], { text: `選擇 ${(item.data?.options?.length || 0) + 1}`, correct: false }]);
    }
    const handleAddAnswers = (item, index) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'answers', [...item.data?.answers || [], { text: `● 標準答案` }]);
    }
    const handleAddTableRow = (item, index) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'table', [...item.data?.table || [], { text: `表格 ${(item.data?.table?.length || 0) + 1}` }]);
    }
    const handleSelectMCAnswer = (item, index, option, optionIndex) => () => {
        let newOptions = [...item.data?.options.slice(0, optionIndex), { ...option, correct: !option?.correct }, ...item.data?.options.slice(optionIndex + 1)]
        if (item?.data?.multipleChoiceType !== '多項選擇題') newOptions = newOptions.map((o, i) => ({ ...o, correct: i === optionIndex ? true : false }))
        if (props.onEditKey) props.onEditKey(item, index, 'options', newOptions)
    }
    const handleSelectTableAnswer1 = (item, index, option, optionIndex) => () => {
        let newTable = [...item.data?.table.slice(0, optionIndex), { ...option, correct1: !option?.correct1, }, ...item.data?.table.slice(optionIndex + 1)]
        if (item?.data?.multipleChoiceType !== '多項選擇題') newTable = [...item.data?.table.slice(0, optionIndex), { ...option, correct1: true, correct2: false }, ...item.data?.table.slice(optionIndex + 1)]
        if (props.onEditKey) props.onEditKey(item, index, 'table', newTable)
    }
    const handleSelectTableAnswer2 = (item, index, option, optionIndex) => () => {
        let newTable = [...item.data?.table.slice(0, optionIndex), { ...option, correct2: !option?.correct2, }, ...item.data?.table.slice(optionIndex + 1)]
        if (item?.data?.multipleChoiceType !== '多項選擇題') newTable = [...item.data?.table.slice(0, optionIndex), { ...option, correct2: true, correct1: false }, ...item.data?.table.slice(optionIndex + 1)]
        if (props.onEditKey) props.onEditKey(item, index, 'table', newTable)
    }
    const handleUpdateMCAnswer = (item, index, option, optionIndex) => (e) => {
        if (props.onEditKey) props.onEditKey(item, index, 'options', [...item.data?.options.slice(0, optionIndex), { ...option, text: e.target.value }, ...item.data?.options.slice(optionIndex + 1)])
    }
    const handleUpdateDemoAnswers = (item, index) => (e) => {
        if (props.onEditKey) props.onEditKey(item, index, 'answers', { ...(item.data?.answers || {}), text: e.target.value })
    }
    const handleRemoveMCOption = (item, index, option, optionIndex) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'options', [...item.data?.options.slice(0, optionIndex), ...item.data?.options.slice(optionIndex + 1)])
    }
    const handleRemoveDemoAnswers = (item, index, option, optionIndex) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'answers', [...item.data?.answers.slice(0, optionIndex), ...item.data?.answers.slice(optionIndex + 1)])
    }
    const handleSelectPopupPage = (item, index) => (page, pageIndex) => {
        if (props.onEditKey) props.onEditKey(item, index, 'popupPageId', props.data?.pages?.filter?.((p, pi) => pi == (Number(pageIndex) - 1))[0]?.id || null);
    }
    const handleRemoveTableRow = (item, index, row, rowIndex) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'table', [...item.data?.table.slice(0, rowIndex), ...item.data?.table.slice(rowIndex + 1)])
    }
    const handleUpdateTableRow = (item, index, row, rowIndex) => (e) => {
        if (props.onEditKey) props.onEditKey(item, index, 'table', [...item.data?.table.slice(0, rowIndex), { ...row, text: e.target.value }, ...item.data?.table.slice(rowIndex + 1)])
    }
    const handleAddDragAndDropColumn = (item, index) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'dragAndDrop', [...item.data?.dragAndDrop || [], { rows: [] }]);
    }
    const onEditDragAndDropTitle = (item, index, columnIndex) => (e) => {
        if (props.onEditKey) props.onEditKey(item, index, 'dragAndDrop', [...item.data?.dragAndDrop.slice(0, columnIndex), { ...item.data?.dragAndDrop[columnIndex], title: e.target.value }, ...item.data?.dragAndDrop.slice(columnIndex + 1)]);
    }
    const handleAddDragAndDropRow = (item, index, column, columnIndex) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'dragAndDrop', [...item.data?.dragAndDrop.slice(0, columnIndex), { ...item.data?.dragAndDrop[columnIndex], rows: [...item.data?.dragAndDrop[columnIndex]?.rows || [], { type: '文字' }] }, ...item.data?.dragAndDrop.slice(columnIndex + 1)]);
    }
    const handleRemoveDragAndDropColumn = (item, index, column, columnIndex) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'dragAndDrop', [...item.data?.dragAndDrop.slice(0, columnIndex), ...item.data?.dragAndDrop.slice(columnIndex + 1)]);
    }
    const onSelectDragAndDropRowType = (item, index, column, columnIndex, row, rowIndex) => (type) => {
        if (props.onEditKey) props.onEditKey(item, index, 'dragAndDrop', [...item.data?.dragAndDrop.slice(0, columnIndex), { ...column, rows: [...column?.rows.slice(0, rowIndex), { ...row, type }, ...column?.rows.slice(rowIndex + 1)] }, ...item.data?.dragAndDrop.slice(columnIndex + 1)]);
    }
    const handleAddDragAndDropOptions = (item, index) => () => {
        if (props.onEditKey) props.onEditKey(item, index, 'dragAndDropOptions', [...item.data?.dragAndDropOptions || [], { text: '選項' }]);
    }

    const redirectRef = useRef([])
    useEffect(() => {
        redirectRef.current = redirectRef.current.slice(0, props.data?.questions?.length || 1);
    }, [props.data?.questions])

    return (
        <div style={{ width: '100%', boxSizing: 'border-box' }}>
            <div className='flex flex-col w-full'>
                <div className='w-full flex flex-row w-full items-center gap-[16px] justify-between py-[2px] px-[16px] text-[14px] font-[700]'>
                    <div className='w-[20px]'></div>
                    <div className='w-[16px]'>#</div>
                    <div className='flex-1'>內容</div>
                </div>
                <ReactGridLayout
                    className='layout'
                    layout={layout}
                    cols={1}
                    rowHeight={rowHeight}
                    maxRows={layout.length * numOfRow}
                    preventCollision={true}
                    allowOverlap={true}
                    isDraggable={true}
                    isResizable={false}
                    onDragStop={onDragStop(layout)}
                    draggableHandle='.drag-handle'
                    style={{ height: layout.length * ((rowHeight + 10) * numOfRow), margin: 0, padding: 0 }}
                >
                    {layout?.map((item, index) => (
                        <div
                            key={item.i}
                            className='flex flex-row w-full items-start py-[8px] gap-[16px] justify-between px-[4px] rounded-[7px]'
                            style={{ border: '2px solid #D9D9D9', height: rowHeight }}
                        >
                            <div className='drag-handle cursor-pointer w-[20px]'>
                                <DragIcon />
                            </div>
                            <div className='w-[16px]'>{Number(index) + 1}</div>
                            <div className='flex-[1] flex flex-col gap-[8px] h-[100%]' style={{ overflowY: 'auto' }}>
                                <div className='font-[700]'>對話</div>
                                <input
                                    className='bg-[#F0F0F0] rounded-[7px] w-full px-[12px] py-[4px]'
                                    style={{}}
                                    value={props.data?.questions[index]?.dialog || ''}
                                    onChange={onEditKey(item, index, 'dialog')}
                                />
                                {/* <MDEditor data-color-mode="light"
                                        className='bg-white'
                                        value={props.data?.questions?.[index]?.name||''}
                                        onChange={(v)=>{onEditKey(item,index,'name')({target:{value:v}})}}
                                /> */}
                                <div className='flex flex-row w-full gap-[16px] flex-wrap'>
                                    <div className='flex flex-col'>
                                        <div className='font-[700]'>彈出新網頁</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                minWidth={250}
                                                value={props.data.pages?.filter((p) => p.id === props.data?.questions[index]?.popupPageId)?.[0]?.name || '--- 無 ---'}
                                                options={['--- 無 ---', ...(props.data?.pages?.map((i, idx) => `#${Number(idx) + 1} ${i.name}`) || [])]}
                                                select={handleSelectPopupPage(item, index)}
                                            />
                                        </div>
                                    </div>
                                    <div className='flex flex-col'>
                                        <div className='font-[700]'>分數</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                minWidth={250}
                                                value={props.data?.questions[index]?.score || '0'}
                                                options={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                                                select={(score) => { if (props.onEditKey) props.onEditKey(item, index, 'score', Number(score) || 0) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='flex flex-col'>
                                        <div className='font-[700]'>問題類型</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={handleSelectQuestionType(item, index)}
                                                value={props.data?.questions[index]?.type || '--- 無 ---'}
                                                minWidth={250}
                                                options={['--- 無 ---', '選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題', '老師導語', '提示語', '拉選題']}
                                            />
                                        </div>
                                    </div>
                                    {['短句作答題'].includes(props.data?.questions[index]?.type) &&  <div className='flex flex-col'>
                                        <div className='font-[700]'>有兩個答案</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                select={(ans) => { if (props.onEditKey) props.onEditKey(item, index, 'hasTwoAnswers', ans==='是') }}
                                                value={props.data?.questions[index]?.hasTwoAnswers? '是' : '否'}
                                                minWidth={250}
                                                options={['是','否']}
                                            />
                                        </div>
                                    </div>}
                                    {['選擇題', '選擇題 + 短句作答題', '表格問題'].includes(props.data?.questions[index]?.type) &&
                                        <div className='flex flex-col'>
                                            <div className='font-[700]'>選擇題類型</div>
                                            <div className='flex flex-row'>
                                                <DropDownMenu
                                                    select={(type) => { if (props.onEditKey) props.onEditKey(item, index, 'multipleChoiceType', type) }}
                                                    value={props.data?.questions[index]?.multipleChoiceType || '單項選擇題'}
                                                    minWidth={250}
                                                    options={['單項選擇題', '多項選擇題']}
                                                />
                                            </div>
                                        </div>
                                    }
                                    {['拉選題','選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題'].includes(props.data?.questions[index]?.type) && <div className='flex flex-col'>
                                        <div className='font-[700]'>能力點</div>
                                        <div className='flex flex-row'>
                                            <DropDownMenu
                                                minWidth={250}
                                                value={ABILITY_POINTS_DICT[props.data?.questions[index]?.abilityPoint] || '--- 無 ---'}
                                                options={ABILITY_POINTS_LIST.map((i) => ABILITY_POINTS_DICT[i])}
                                                select={(ap) => { if (props.onEditKey) props.onEditKey(item, index, 'abilityPoint', ABILITY_POINTS_DICT_2[ap] || '') }}
                                            />
                                        </div>
                                    </div>}
                                </div>
                                {props.data?.questions[index]?.type === '選擇網頁' && (
                                    <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                        <div className='font-[700]'>選擇網頁</div>
                                        {item?.data?.options?.map((option, optionIndex) => (
                                            <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                                <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                    <button
                                                        className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${option.correct ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                        onClick={handleSelectMCAnswer(item, index, option, optionIndex)}
                                                    ></button>
                                                </div>
                                                <input
                                                    className='flex-1 bg-[#F0F0F0] rounded-[7px] px-[12px] py-[4px]'
                                                    placeholder='標題'
                                                    value={option.text}
                                                    onChange={ (e) => {
                                                        if (props.onEditKey) props.onEditKey(item, index, 'options', [...item.data?.options.slice(0, optionIndex), { ...option, text: e.target.value }, ...item.data?.options.slice(optionIndex + 1)])
                                                    }}
                                                />
                                                <input
                                                    className='flex-1 bg-[#F0F0F0] rounded-[7px] px-[12px] py-[4px]'
                                                    placeholder='url'
                                                    value={option.url}
                                                    onChange={ (e) => {
                                                        if (props.onEditKey) props.onEditKey(item, index, 'options', [...item.data?.options.slice(0, optionIndex), { ...option, url: e.target.value }, ...item.data?.options.slice(optionIndex + 1)])
                                                    }}
                                                />
                                                <input
                                                    className='flex-1 bg-[#F0F0F0] rounded-[7px] px-[12px] py-[4px]'
                                                    placeholder='描述'
                                                    value={option.description}
                                                    onChange={ (e) => {
                                                        if (props.onEditKey) props.onEditKey(item, index, 'options', [...item.data?.options.slice(0, optionIndex), { ...option, description: e.target.value }, ...item.data?.options.slice(optionIndex + 1)])
                                                    }}
                                                />
                                                <div onClick={handleRemoveMCOption(item, index, option, optionIndex)} className='cursor-pointer'>
                                                    <CrossIcon />
                                                </div>
                                            </div>
                                        ))}
                                        <div className='flex flex-row'>
                                            <div
                                                onClick={
                                                    () => {
                                                        if (props.onEditKey) props.onEditKey(item, index, 'options', [...item.data?.options || [], { text: `網頁 ${(item.data?.options?.length || 0) + 1}`, url: 'https://', description: '', correct: false }]);
                                                    }
                                                }
                                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                style={{ border: '1px solid #1F4CC8' }}
                                            >
                                                <AddSvg />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/*multiple choice question*/}
                                {['選擇題', '選擇題 + 短句作答題','拉選題'].includes(props.data?.questions[index]?.type) && (
                                    <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                        <div className='font-[700]'>選擇題問題</div>
                                        {/* <input
                                            className='bg-[#F0F0F0] rounded-[7px] w-full px-[12px] py-[4px]'
                                            style={{}}
                                            placeholder='問題<'
                                            value={props.data?.questions[index]?.question || ''}
                                            onChange={onEditKey(item, index, 'question')}
                                        /> */}
                                        <MDEditor data-color-mode="light"
                                            style={{ minHeight: 100 }}
                                            className='bg-white'
                                            value={props.data?.questions?.[index]?.question || ''}
                                            onChange={(v) => { onEditKey(item, index, 'question')({ target: { value: v } }) }}
                                        />
                                        <div className='font-[700]'>選擇題答案</div>
                                        {item?.data?.options?.map((option, optionIndex) => (
                                            <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                                <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                    <button
                                                        className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${option.correct ? 'bg-blue-500' : 'bg-[#fafafa]'
                                                            }`}
                                                        onClick={handleSelectMCAnswer(item, index, option, optionIndex)}
                                                    ></button>
                                                </div>
                                                <input
                                                    className='flex-1 bg-[#F0F0F0] rounded-[7px] px-[12px] py-[4px]'
                                                    placeholder='選擇'
                                                    value={option.text}
                                                    onChange={handleUpdateMCAnswer(item, index, option, optionIndex)}
                                                />
                                                <div onClick={handleRemoveMCOption(item, index, option, optionIndex)} className='cursor-pointer'>
                                                    <CrossIcon />
                                                </div>
                                            </div>
                                        ))}
                                        <div className='flex flex-row'>
                                            <div
                                                onClick={handleAddOption(item, index)}
                                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                style={{ border: '1px solid #1F4CC8' }}
                                            >
                                                <AddSvg />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/*end of multiple choice question*/}

                                {/*open end question*/}
                                {['短句作答題', '選擇題 + 短句作答題'].includes(props.data?.questions[index]?.type) && (
                                    <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                        <div className='font-[700]'>短句作答題問題</div>
                                        {/* <input
                                            className='bg-[#F0F0F0] rounded-[7px] w-full px-[12px] py-[4px]'
                                            style={{}}
                                            placeholder='問題'
                                            value={props.data?.questions[index]?.question || ''}
                                            onChange={onEditKey(item, index, 'question')}
                                        /> */}
                                        <MDEditor data-color-mode="light"
                                            style={{ minHeight: 100 }}
                                            className='bg-white'
                                            value={props.data?.questions?.[index]?.questionShortanswer || ''}
                                            onChange={(v) => { onEditKey(item, index, 'questionShortanswer')({ target: { value: v } }) }}
                                        />
                                    </div>
                                )}
                                {/*end of open end question*/}

                                {/*form table question*/}
                                {['表格問題'].includes(props.data?.questions[index]?.type) && (
                                    <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                        <div className='font-[700]'>表格問題</div>
                                        {/* <input
                                            className='bg-[#F0F0F0] rounded-[7px] w-full px-[12px] py-[4px]'
                                            style={{}}
                                            placeholder='問題'
                                            value={props.data?.questions[index]?.question || ''}
                                            onChange={onEditKey(item, index, 'question')}
                                        /> */}
                                        <MDEditor data-color-mode="light"
                                            style={{ minHeight: 100 }}
                                            className='bg-white'
                                            value={props.data?.questions?.[index]?.question || ''}
                                            onChange={(v) => { onEditKey(item, index, 'question')({ target: { value: v } }) }}
                                        />
                                        <div className='font-[700]'>表格</div>
                                        <div className='flex flex-col w-full'>
                                            <div className='flex flex-row items-center w-full border-black font-[700]'>
                                                <input
                                                    className='bg-[#777] text-white flex-1 border-[black] border-[1px] w-full px-[12px] py-[4px]'
                                                    style={{}}
                                                    value={props.data?.questions[index]?.header?.[0] || ''}
                                                    onChange={onEditTableHeader(item, index, 0)}
                                                />
                                                <input
                                                    className='bg-[#777] text-white border-[black] border-[1px] px-[12px] py-[4px] w-[100px] text-center'
                                                    style={{}}
                                                    value={props.data?.questions[index]?.header?.[1] || ''}
                                                    onChange={onEditTableHeader(item, index, 1)}
                                                />
                                                <input
                                                    className='bg-[#777] text-white border-[black] border-[1px] px-[12px] py-[4px] w-[100px] text-center'
                                                    style={{}}
                                                    value={props.data?.questions[index]?.header?.[2] || ''}
                                                    onChange={onEditTableHeader(item, index, 2)}
                                                />
                                                <div className='opacity-[0]  ml-[8px]'>
                                                    <CrossIcon />
                                                </div>
                                            </div>
                                            {item?.data?.table?.map((row, rowIndex) => (
                                                <div key={rowIndex} className='flex flex-row items-stretch'>
                                                    <input
                                                        className='flex-1 bg-[#F0F0F0] border-black border-x-[1px] border-y-[1px] px-[12px] py-[4px]'
                                                        placeholder=''
                                                        value={row.text}
                                                        onChange={handleUpdateTableRow(item, index, row, rowIndex)}
                                                    />
                                                    <div className='w-[100px] border-[black] border-[1px] px-[12px] py-[4px] flex flex-row justify-center items-center bg-[#F0F0F0]'>
                                                        <div>
                                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                                <button
                                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.correct1 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                                    onClick={handleSelectTableAnswer1(item, index, row, rowIndex)}
                                                                ></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='w-[100px] border-[black] border-[1px] px-[12px] py-[4px] flex flex-row justify-center justify-center items-center bg-[#F0F0F0]'>
                                                        <div>
                                                            <div className='flex bg-[#ddd] rounded-full p-[1px]'>
                                                                <button
                                                                    className={`w-[20px] h-[20px] rounded-full border-[5px] border-[#fafafa] ${row.correct2 ? 'bg-blue-500' : 'bg-[#fafafa]'}`}
                                                                    onClick={handleSelectTableAnswer2(item, index, row, rowIndex)}
                                                                ></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div onClick={handleRemoveTableRow(item, index, row, rowIndex)} className='cursor-pointer ml-[8px]'>
                                                        <CrossIcon />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className='flex flex-row'>
                                            <div
                                                onClick={handleAddTableRow(item, index)}
                                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                style={{ border: '1px solid #1F4CC8' }}
                                            >
                                                <AddSvg />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/*end of form table question*/}


                                {/*drag and drop question*/}
                                {['拖放式問題'].includes(props.data?.questions[index]?.type) && (
                                    <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                        <div className='font-[700]'>拖放式問題</div>
                                        {/* <input
                                            className='bg-[#F0F0F0] rounded-[7px] w-full px-[12px] py-[4px]'
                                            style={{}}
                                            placeholder='問題'
                                            value={props.data?.questions[index]?.question || ''}
                                            onChange={onEditKey(item, index, 'question')}
                                        /> */}
                                        <MDEditor data-color-mode="light"
                                            style={{ minHeight: 100 }}
                                            className='bg-white'
                                            value={props.data?.questions?.[index]?.question || ''}
                                            onChange={(v) => { onEditKey(item, index, 'question')({ target: { value: v } }) }}
                                        />
                                        <div className='font-[700]'>表格</div>
                                        <div className='w-full flex flex-row justify-start items-stretch'>
                                            {item?.data?.dragAndDrop?.map((column, columnIndex) =>
                                                <div key={columnIndex} className='bg-[grey] p-[2px] min-w-[100px] form-input flex flex-col'>
                                                    <div className='flex flex-col flex-[1] w-full gap-[4px]'>
                                                        <input
                                                            className='bg-[#aaa] text-white w-full px-[12px] py-[4px]'
                                                            placeholder='文字'
                                                            style={{}}
                                                            value={column?.title || ''}
                                                            onChange={onEditDragAndDropTitle(item, index, columnIndex)}
                                                        />
                                                        {column?.rows?.map((row, rowIndex) =>
                                                            <div key={rowIndex} className='bg-white p-[2px] relative'>
                                                                <div className='font-[700]'>類型</div>
                                                                <DropDownMenu value={row.type} options={['文字', '拖放格', '空白區域']} select={onSelectDragAndDropRowType(item, index, column, columnIndex, row, rowIndex)} />
                                                                <div className='font-[700]'>格大小:</div>
                                                                <DropDownMenu value={row.size || 1} options={[1, 2, 3, 4, 5]} select={(size) => {
                                                                    if (props.onEditKey) props.onEditKey(item, index, 'dragAndDrop', [...item.data?.dragAndDrop.slice(0, columnIndex), { ...column, rows: [...column?.rows.slice(0, rowIndex), { ...row, size }, ...column?.rows.slice(rowIndex + 1)] }, ...item.data?.dragAndDrop.slice(columnIndex + 1)])
                                                                }} />

                                                                {row?.type === '拖放格' && <div className='flex flex-col'>
                                                                    <div className='font-[700]'>答案:</div>
                                                                    <DropDownMenu value={row.answer || '--- 無 ---'} options={['--- 無 ---', ...(item?.data?.dragAndDropOptions || []).map((o) => o.text)]} select={
                                                                        (type) => { if (props.onEditKey) props.onEditKey(item, index, 'dragAndDrop', [...item.data?.dragAndDrop.slice(0, columnIndex), { ...column, rows: [...column?.rows.slice(0, rowIndex), { ...row, answer: type }, ...column?.rows.slice(rowIndex + 1)] }, ...item.data?.dragAndDrop.slice(columnIndex + 1)]) }
                                                                    } />
                                                                </div>}
                                                                {row?.type === '文字' && <div className='flex flex-col'>
                                                                    <div className='font-[700]'>文字:</div>
                                                                    <input placeholder='文字' className='border-[0.5px] border-[#00000080] px-[16px] py-[6px] rounded-[7px]' value={row?.text || ''} onChange={(e) => { if (props.onEditKey) props.onEditKey(item, index, 'dragAndDrop', [...item.data?.dragAndDrop.slice(0, columnIndex), { ...column, rows: [...column?.rows.slice(0, rowIndex), { ...row, text: e.target.value }, ...column?.rows.slice(rowIndex + 1)] }, ...item.data?.dragAndDrop.slice(columnIndex + 1)]) }} />
                                                                </div>}
                                                                <div className='absolute cursor-pointer top-[2px] right-[2px]' onClick={
                                                                    () => { if (props.onEditKey) props.onEditKey(item, index, 'dragAndDrop', [...item.data?.dragAndDrop.slice(0, columnIndex), { ...column, rows: [...column?.rows.slice(0, rowIndex), ...column?.rows.slice(rowIndex + 1)] }, ...item.data?.dragAndDrop.slice(columnIndex + 1)]) }
                                                                }>
                                                                    <CrossIcon />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    <div className='flex flex-row mt-[16px] items-center justify-between'>
                                                        <div
                                                            onClick={handleAddDragAndDropRow(item, index, column, columnIndex)}
                                                            className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                            style={{ border: '1px solid #1F4CC8' }}
                                                        >
                                                            <AddSvg />行
                                                        </div>
                                                        <div onClick={handleRemoveDragAndDropColumn(item, index, column, columnIndex)} className='cursor-pointer ml-[8px]'>
                                                            <CrossIcon />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className='flex flex-row'>
                                            <div
                                                onClick={handleAddDragAndDropColumn(item, index)}
                                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                style={{ border: '1px solid #1F4CC8' }}
                                            >
                                                <AddSvg />列
                                            </div>
                                        </div>
                                        <div className='flex flex-row w-full gap-[8px] flex-wrap'>
                                            {item?.data?.dragAndDropOptions?.map((option, optionIndex) => (
                                                <div key={optionIndex} className='flex flex-row gap-[8px] items-center'>
                                                    <input
                                                        className='bg-[#F0F0F0] rounded-[7px] px-[12px] py-[4px] min-w-[400px]'
                                                        placeholder='選項'
                                                        value={option.text}
                                                        onChange={(e) => { if (props.onEditKey) props.onEditKey(item, index, 'dragAndDropOptions', [...item.data?.dragAndDropOptions.slice(0, optionIndex), { ...option, text: e.target.value }, ...item.data?.dragAndDropOptions.slice(optionIndex + 1)]) }}
                                                    />
                                                    <div onClick={() => { if (props.onEditKey) props.onEditKey(item, index, 'dragAndDropOptions', [...item.data?.dragAndDropOptions.slice(0, optionIndex), ...item.data?.dragAndDropOptions.slice(optionIndex + 1)]) }} className='cursor-pointer'>
                                                        <CrossIcon />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className='flex flex-row'>
                                            <div
                                                onClick={handleAddDragAndDropOptions(item, index)}
                                                className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                style={{ border: '1px solid #1F4CC8' }}
                                            >
                                                <AddSvg />選項
                                            </div>
                                        </div>
                                    </div>
                                )}



                                {['拉選題','選擇網頁', '選擇題', '短句作答題', '選擇題 + 短句作答題', '表格問題', '拖放式問題'].includes(props.data?.questions[index]?.type) &&
                                    <div className='w-full flex flex-col p-[16px] bg-[#F8F8F8] gap-[8px] rounded-[7px]'>
                                        <div className='font-[700]'>標準答案</div>

                                        <div className='flex flex-col gap-[8px] w-full'>
                                            <div className='flex flex-row gap-[8px] items-center w-full'>
                                                <textarea
                                                    style={{ minHeight: 100 }}
                                                    className='bg-[#fff] rounded-[7px] px-[12px] py-[4px] flex-1'
                                                    value={item?.data?.answers?.text || ''}
                                                    onChange={handleUpdateDemoAnswers(item, index)}
                                                    ref={el => redirectRef.current[index] = el}
                                                />
                                            </div>
                                            <div className='flex flex-row mt-[64px]'>
                                                <div
                                                    onClick={() => {
                                                        if (redirectRef.current[index]?.selectionStart == undefined || redirectRef.current[index]?.selectionEnd === undefined) {
                                                            alert('請在上面的輸入欄位中選擇文字'); return
                                                        } if (redirectRef.current[index]?.selectionStart === redirectRef.current[index]?.selectionEnd) {
                                                            alert('請在上面的輸入欄位中選擇文字'); return
                                                        }
                                                        if (props.onEditKey) props.onEditKey(item, index, 'answers', {
                                                            ...item?.data?.answers, popups:
                                                                [...item?.data?.answers?.popups || [], {
                                                                    start: redirectRef.current[index]?.selectionStart,
                                                                    end: redirectRef.current[index]?.selectionEnd,
                                                                }]
                                                        })

                                                    }}
                                                    className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[8px] py-[8px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                                                    style={{ border: '1px solid #1F4CC8' }}
                                                >
                                                    <AddSvg /> 彈出視窗
                                                </div>
                                            </div>



                                            {/*handle explanation popup*/}
                                            <div className='flex flex-col w-full gap-[8px]'>
                                                <div className='flex flex-col gap-[8px]'>
                                                    {item?.data?.answers?.popups?.map((r, ri) =>
                                                        <div key={ri} className='w-full flex flex-col gap-[8px] mt-[64px]'>
                                                            <div className='flex flex-row gap-[16px] items-center flex-wrap'>
                                                                <div className='font-bold'>#{Number(ri) + 1} 彈出視窗文字:</div>
                                                                <div className='text-[blue] cursor-pointer underline'>{item?.data?.answers?.text?.slice(r?.start, r?.end)}</div>
                                                                <div className='flex-1 flex flex-row justify-end'>
                                                                    <div className='cursor-pointer' onClick={() => {
                                                                        if (props.onEditKey) props.onEditKey(item, index, 'answers', {
                                                                            ...item?.data?.answers, popups:
                                                                                [...item?.data?.answers?.popups.slice(0, ri), ...item?.data?.answers?.popups.slice(ri + 1)]
                                                                        })
                                                                    }}>
                                                                        <CrossIcon />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div>網頁:</div>
                                                            <DropDownMenu
                                                                value={props.data?.pages?.filter(p => p.id === item?.data?.answers?.popups?.[ri]?.page_id)?.[0]?.name || '--- 無 ---'}
                                                                options={['--- 無 ---', ...(props.data?.pages?.map((i, idx) => `#${Number(idx) + 1} ${i.name}`) || [])]}
                                                                select={(page, pi) => {
                                                                    if (props.onEditKey) props.onEditKey(item, index, 'answers', {
                                                                        ...item?.data?.answers, popups:
                                                                            [...item?.data?.answers?.popups.slice(0, ri), { ...r, page_id: page === '--- 無 ---' ? null : props.data?.pages?.[Number(pi) - 1].id, content_id: null }, ...item?.data?.answers?.popups.slice(ri + 1)]
                                                                    })
                                                                }}
                                                            />
                                                            {item?.data?.answers?.popups?.[ri].page_id && <div>選擇標記段落:</div>}
                                                            {item?.data?.answers?.popups?.[ri].page_id && <DropDownMenu
                                                                value={item?.data?.answers?.popups?.[ri]?.content_id === null ? '--- 無 ---' : `段落 ${Number(item?.data?.answers?.popups?.[ri]?.content_id) + 1}`}
                                                                options={['--- 無 ---', ...(props.data?.pages?.filter(p => p.id === item?.data?.answers?.popups?.[ri].page_id)?.[0]?.contents?.map((i, idx) => `#${Number(idx) + 1} ${i.type} ${i?.text.slice(0, 50)} ...`) || [])]}
                                                                select={(content, content_index) => {
                                                                    if (props.onEditKey) props.onEditKey(item, index, 'answers', {
                                                                        ...item?.data?.answers, popups:
                                                                            [...item?.data?.answers?.popups.slice(0, ri), { ...r, content_id: content === '--- 無 ---' ? null : Number(content_index) - 1 }, ...item?.data?.answers?.popups.slice(ri + 1)]
                                                                    })
                                                                }}
                                                            />}
                                                            {item?.data?.answers?.popups?.[ri].page_id && item?.data?.answers?.popups?.[ri].content_id >= 0 && <div>選擇標記內容:</div>}
                                                            {item?.data?.answers?.popups?.[ri].page_id && item?.data?.answers?.popups?.[ri].content_id >= 0 &&
                                                                <SelectHighlighttext onSubmit={(popupStart, popupEnd) => {
                                                                    if (props.onEditKey)
                                                                        props.onEditKey(item, index, 'answers', {
                                                                            ...item?.data?.answers, popups:
                                                                                [...item?.data?.answers?.popups.slice(0, ri), { ...r, popupStart, popupEnd }, ...item?.data?.answers?.popups.slice(ri + 1)]
                                                                        })
                                                                }}
                                                                    value={props.data?.pages?.filter(p => p.id === item?.data?.answers?.popups?.[ri].page_id)?.[0]?.contents?.[item?.data?.answers?.popups?.[ri]?.content_id]?.text || ""} />
                                                            }
                                                            <div className='font-[700]'>要標記的文字:</div>
                                                            <div className='flex-1'>
                                                                <input
                                                                    className='bg-white rounded-[7px] p-[8px] w-full'
                                                                    value={r.popupStart && r.popupEnd && props.data?.pages?.filter(p => p.id === item?.data?.answers?.popups?.[ri].page_id)?.[0]?.contents?.[item?.data?.answers?.popups?.[ri]?.content_id]?.text.slice(r.popupStart, r.popupEnd) || ""}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* <div className='font-[700]'>預覽</div>
                                                <div className={`p-[16px]`} style={{ backgroundColor: item?.backgroundColor || 'white', textAlign: 'left' }}>
                                                    <div style={{ whiteSpace: 'pre-wrap', color: item.color || "black", backgroundColor: "transparent" }}>
                                                        <div className='inline' dangerouslySetInnerHTML={{ __html: (item.popups?.[0] ? item?.text?.slice(0, item.popups?.[0]?.start) : item?.text) || '' }} />
                                                        {item.popups?.sort((a, b) => (a.start > b.start) ? 1 : (a.start < b.start) ? -1 : 0
                                                        )?.map((r, ri) =>
                                                            <div className='inline' key={ri}>
                                                                <div className='inline text-[blue] cursor-pointer underline' onClick={() => { setisShowPopup(r.text) }} dangerouslySetInnerHTML={{ __html: item?.text.slice(r.start, r.end) }} />
                                                                <div className='inline' dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        item.popups?.[ri + 1] ?
                                                                            item?.text.slice(r.end, item.popups?.[ri + 1].start)
                                                                            : item?.text.slice(r.end)
                                                                }} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div> */}
                                            </div>
                                            {/* end of handle explanation popup*/}
                                        </div>
                                    </div>
                                }
                            </div>

                            <div className='cursor-pointer' onClick={onDelete(item, index)}>
                                <RemoveIcon />
                            </div>
                        </div>
                    ))}
                </ReactGridLayout>
                <div className='flex flex-row mt-[16px] p-[10px]'>
                    <div
                        className='flex flex-row items-center gap-[10px] text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]'
                        style={{ border: '1px solid #1F4CC8' }}
                        onClick={onAddCard}
                    >
                        <AddSvg /> 添加對話
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Component





const DragIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={17}
        fill="none"
        {...props}
    >
        <g clipPath="url(#a)">
            <path
                fill="#000"
                d="M2 12.311h12v-1.333H2v1.333Zm0-3.333h12V7.644H2v1.334ZM2 4.31v1.333h12V4.311H2Z"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 .311h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
)

const RemoveIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={21}
        fill="none"
        {...props}
    >
        <path
            fill="#212121"
            d="M1.364 18.15a2.238 2.238 0 0 0 2.231 2.231h8.926a2.238 2.238 0 0 0 2.232-2.231V4.76H1.363v13.39ZM3.595 6.992h8.926V18.15H3.595V6.992Zm8.368-5.578L10.848.298h-5.58L4.154 1.414H.248v2.231h15.62V1.414h-3.905Z"
        />
    </svg>
)

function CrossIcon(props) {
    return (
        <svg
            width={21}
            height={21}
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle
                cx={10.1461}
                cy={10.1461}
                r={9.89242}
                fill="#F9FAFB"
                stroke="#111827"
                strokeWidth={0.507303}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.689 13.51a.64.64 0 11-.906-.906l2.458-2.458-2.458-2.458a.64.64 0 11.906-.906l2.458 2.458 2.458-2.458a.64.64 0 01.905.906l-2.458 2.458 2.458 2.458a.64.64 0 01-.905.905l-2.458-2.458-2.458 2.458z"
                fill="#111827"
            />
        </svg>
    )
}